<template>
    <div class="box">
        <div class="box-body">
            <div class="row">
                <div class="col-12">
                    <dropdown
                            class="form-control"

                            value-field="value"
                            text-field="text"
                            v-bind:placeholder="resource('SettingsDivisionMiscellaneous_Index_CategoryDropdown_Placeholder')"
                            v-bind:options="sortedCategoryDropdownOptions"
                            v-bind:value="selectedCategory.id"

                            @input="categorySelected"
                    >
                    </dropdown>
                </div>
            </div>
            
            <div class="row">
                <div class="col-12">
                    <hr />
                </div>
            </div>
            
            <div class="row">
                <div class="col-8 form-group">
                    <div class="row">
                        <div class="col-6">
                            <h3>{{resource('SettingsDivisionMiscellaneous_Index_CategoryHeader')}}</h3>
                        </div>
                        <div class="col-6 text-right">
                            <button 
                                v-if="canSaveCategory" 
                                class="btn btn-primary" 
                                @click="saveCategory">{{resource('SettingsDivisionMiscellaneous_Index_SaveButton_Text')}}
                            </button>
                            <button 
                                v-if="canDeleteCategory" 
                                class="btn btn-danger" 
                                @click="deleteCategory">{{resource('SettingsDivisionMiscellaneous_Index_DeleteButton_Text')}}
                            </button>
                        </div>
                    </div>
                </div>
                
                <div class="col-8">
                    <miscellaneous-category v-bind:category="selectedCategory"></miscellaneous-category>
                </div>

                <div class="col-8 text-right">
                    <button v-if="canSaveCategory" class="btn btn-primary" @click="saveCategory">{{resource('SettingsDivisionMiscellaneous_Index_SaveButton_Text')}}</button>
                    <button v-if="canDeleteCategory" class="btn btn-danger" @click="deleteCategory">{{resource('SettingsDivisionMiscellaneous_Index_DeleteButton_Text')}}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import settingsDivisionMiscellaneousApi from '../../../Api/settings-division-miscellaneous';
    import growler from "../../../Util/growler";
    import {promptV2 as prompt} from "../../../Util/prompt";
    import _ from 'lodash';
    
    import resourceMixin from '../../../Util/Mixins/resources'
    
    import Dropdown from '../../../Components/FormControls/Dropdown.vue'
    import MiscellaneousCategory from "./MiscellaneousCategory.vue";
    
    export default {
        name: "settings-division-miscellaneous-index",
        components: {
            MiscellaneousCategory,
            Dropdown
        },
        mixins: [resourceMixin],
        created(){
            const vm = this;

            vm.selectedCategory = vm.createEmptyCategory();
            
            settingsDivisionMiscellaneousApi.validateWritePermission()
                .then(canWrite => vm.canWrite = canWrite);

            settingsDivisionMiscellaneousApi.validateDeletePermission()
                .then(canDelete => vm.canDelete = canDelete);
            
            vm.loadCategoryDropdownOptions();
        },
        methods: {
            categorySelected(categoryId){
                const vm = this;
                
                //New category
                if(!categoryId){
                    vm.selectedCategory = vm.createEmptyCategory();
                    return;
                }
                
                settingsDivisionMiscellaneousApi.getCategory(categoryId).then(
                    selectedCategory => vm.selectedCategory = selectedCategory,
                    err => growler.bootstrapDanger(err.join('\n'))
                );
            },
            createEmptyCategory(){
                return {
                    _isNew: true,
                    fields: []
                }
            },
            saveCategory(){
                const vm = this;
                
                const action = vm.selectedCategory._isNew ?
                    settingsDivisionMiscellaneousApi.createCategory :
                    settingsDivisionMiscellaneousApi.updateCategory;
                
                action(vm.selectedCategory).then(
                    category => {
                        growler.bootstrapSuccess(vm.resource('SettingsDivisionMiscellaneous_Index_SaveSuccess_Notification'));
                        
                        vm.selectedCategory = category;
                        
                        //Include our new category
                        vm.loadCategoryDropdownOptions();
                    },
                    err => growler.bootstrapDanger(err.join('\n'))
                );
            },
            deleteCategory(){
                const vm = this;
                
                //Can't delete a category that is yet to be created
                if(vm.selectedCategory._isNew){
                    return;
                }

                prompt(
                    vm.resource('SettingsDivisionMiscellaneous_Index_DeletePromptHeader'), 
                    vm.resource('SettingsDivisionMiscellaneous_Index_DeletePromptBody')
                ).then(() => {
                    settingsDivisionMiscellaneousApi.deleteCategory(vm.selectedCategory.id).then(
                        () => {
                            growler.bootstrapInfo(vm.resource('SettingsDivisionMiscellaneous_Index_DeleteSuccess_Notification'));

                            vm.selectedCategory = vm.createEmptyCategory();
                            vm.loadCategoryDropdownOptions();
                        },
                        err => growler.bootstrapDanger(err.join('\n'))
                    )
                });
            },
            loadCategoryDropdownOptions(){
                const vm = this;

                return settingsDivisionMiscellaneousApi.getCategoryDropdownOptions().then(
                    dropdownOptions => vm.categoryDropdownOptions = dropdownOptions,
                    err => growler.bootstrapDanger(err.join('\n'))
                );
            }
        },
        computed: {
            sortedCategoryDropdownOptions(){
                return _.sortBy(this.categoryDropdownOptions, 'text');
            },
            canDeleteCategory(){
                return this.canDelete && !this.selectedCategory._isNew;
            },
            canSaveCategory(){
                return this.canWrite;
            }
        },
        data: () => ({
            canWrite: false,
            canDelete: false,
            categoryDropdownOptions: [],
            selectedCategory: {}
        })
    }
</script>

<style scoped>

</style>